import React from "react";
import { Scrollbars } from "react-custom-scrollbars";

const CustomScrollbars = ({autoHide,...rest}) => (
  <Scrollbars
    {...rest}
    autoHide={autoHide}
    renderTrackHorizontal={props => (
      <div
        {...props}
        style={{ display: "none" }}
        className="track-horizontal"
      />
    )}
  />
);

export default CustomScrollbars;
